// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3hasz","circle":"Loader_circle__3_imu","rotate":"Loader_rotate__3QseU","label":"Loader_label__3oM48"};